declare namespace $ {

	type $mol_text__text_shm_hitalama_benchmarks_page_metrics_delete_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_hitalama_benchmarks_page_metrics_delete_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_benchmarks_page_metrics_delete_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics_delete['confirm'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_benchmarks_page_metrics_delete_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_benchmarks_page_metrics_delete_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics_delete['cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_benchmarks_page_metrics_delete_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_benchmarks_page_metrics_delete extends $mol_pick {
		enabled( ): boolean
		Icon( ): $mol_icon_delete
		Question( ): $mol_text
		confirm( next?: any ): any
		Confirm( ): $mol_button_minor
		cancel( next?: any ): any
		Cancel( ): $mol_button_minor
		Content( ): $mol_view
		hint( ): string
		trigger_enabled( ): ReturnType< $shm_hitalama_benchmarks_page_metrics_delete['enabled'] >
		align( ): string
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
		remove( next?: any ): any
	}
	
}

//# sourceMappingURL=delete.view.tree.d.ts.map